/** @format */

const isLoading = (state) => state.overlay.isLoading
const errorMessage = (state) => state.overlay.errorMessage
const isOpenSidebar = (state) => state.overlay.isOpenSidebar

export const overlaySelectors = { isLoading, errorMessage, isOpenSidebar }
